import { ReactNode } from 'react';
import { Box, Grid, Typography, useTheme } from '@mui/material';

// Displayed in place of a value the official has not provided
export const EM_DASH = '—';

export type DetailRow = {
  label: string;
  value: string | ReactNode;
  testId?: string;
};

interface DetailsSectionProps {
  title: string;
  rows: DetailRow[];
}

const DetailsSection = ({ title, rows }: DetailsSectionProps) => {
  const theme = useTheme();

  return (
    <Box>
      <Box sx={{
        pb: 1.5
      }}>
        <Typography variant='s' component='h2'>{title}</Typography>
      </Box>
      {rows.map(({ label, value, testId }, idx) => (
        <Grid
          container
          key={label}
          data-testid={testId}
          sx={[{
            py: 1.5
          }, idx === 0 ? false : { borderTop: `1px solid ${theme.palette.divider}` }]}>
          <Grid sx={{ width: 160, flexShrink: 0 }}>
            <Typography variant='bodyMedium' sx={{ color: theme.palette.text.secondary }}>
              {label}
            </Typography>
          </Grid>
          <Grid size='grow' sx={{ minWidth: 0 }}>
            {typeof value === 'string'
              ? (
                <Typography
                  variant='bodyMedium'
                  sx={{
                    color: value === EM_DASH ? theme.palette.text.disabled : theme.palette.text.primary,
                    fontWeight: 500,
                    overflowWrap: 'anywhere'
                  }}>
                  {value}
                </Typography>
              )
              : value}
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export default DetailsSection;
